import Vue from 'vue'
import VueRouter from 'vue-router'
import Report from '../views/Report.vue'
import PreviousData from '../views/PreviousData.vue'
import Configuration from '../views/Configuration.vue'
import QA from '../views/QA.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Report',
    component: Report,
    props: true
  },
  {
    path: '/previous_data',
    name: 'PreviousData',
    component: PreviousData,
    props: true
  },
  {
    path: '/option/configuration',
    name: 'Configuration',
    component: Configuration
  },
  {
    path: '/option/qa',
    name: 'QA',
    component: QA
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
